import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Feature {
  id: string;
  name: string;
  route: string;
  icon: string;
  description: string;
}

interface DashboardProps {
  features: Feature[];
}

const Dashboard: React.FC<DashboardProps> = ({ features }) => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-container" style={{
      padding: '40px',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      {/* Welcome Section */}
      <div style={{ 
        marginBottom: '48px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '300',
          color: '#ffffff',
          marginBottom: '16px',
          letterSpacing: '-0.5px'
        }}>
          Profile Hub
        </h1>
        <p style={{
          fontSize: '18px',
          color: 'rgba(255, 255, 255, 0.7)',
          maxWidth: '600px',
          margin: '0 auto',
          lineHeight: '1.6'
        }}>
          Generate tailored professional profiles, team bios, and enhanced CVs using
          AI-powered tools designed to showcase expertise and match opportunities.
        </p>
      </div>

      {/* Features Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '24px',
        marginBottom: '48px'
      }}>
        {features.map((feature) => (
          <div
            key={feature.id}
            onClick={() => navigate(feature.route)}
            style={{
              background: 'rgba(255, 255, 255, 0.08)',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              borderRadius: '16px',
              padding: '32px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(20px)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 20px 60px rgba(0, 0, 0, 0.3)';
              e.currentTarget.style.borderColor = 'rgba(79, 172, 254, 0.5)';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.2)';
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '20px'
            }}>
              {/* Feature Icon */}
              <div style={{
                width: '64px',
                height: '64px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #4FACFE 0%, #00B4DB 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                boxShadow: '0 8px 24px rgba(79, 172, 254, 0.3)',
                overflow: 'hidden',
                position: 'relative'
              }}>
                <span className="material-icons" style={{ 
                  fontSize: '32px', 
                  color: 'white'
                }}>
                  {feature.icon}
                </span>
              </div>
              
              {/* Feature Content */}
              <div style={{ flex: 1 }}>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#ffffff',
                  marginBottom: '8px'
                }}>
                  {feature.name}
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: 'rgba(255, 255, 255, 0.7)',
                  lineHeight: '1.5',
                  marginBottom: '16px'
                }}>
                  {feature.description}
                </p>
                
                {/* Launch Button */}
                <button style={{
                  background: 'linear-gradient(135deg, #4FACFE 0%, #00B4DB 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
                >
                  <span>Launch</span>
                  <span className="material-icons" style={{ fontSize: '16px' }}>arrow_forward</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Dashboard;